
import { Injectable } from '@angular/core';
import moment from 'moment';
import { PlanningTask } from 'src/app/interfaces/api/task';
import { Config } from 'src/app/interfaces/shared/config';

@Injectable()
export class PlanningTools {

    defaultTask = {
        id: "",
        dbId: "",
        number: 0,
        cost: 0,
        progress: 0,
        indent: 0,
        volume: 0,
        children: [],
        parentTask: null,
        fragments: [],
        fragmentDbIds: [],
        text: "default task",
        firstUpdate: "",
        lastUpdate: "",
        beginDate: '',
        doneDate: '',
        detections: [],
        startDate: moment().toISOString(),
        parent: 0,
        duration: 1,
        endDate: "",
        fragmentData: undefined,
        metrics: [],
        metricData: undefined,
        planning: '',
        resources: [],
        target: '',
        uid: '',
        type: '1',
        uuid: '',
        volumeProgress: 0.00,
    }

    sortTasks(tasks: PlanningTask[]): PlanningTask[] {
        const map = new Map<string, PlanningTask>();
        const pointed = new Set<string>();

        // indexation
        for (const t of tasks) {
            map.set(t.uid || t.id, t);
            if (t.target !== null) {
                pointed.add(t.target || "0");
            }
        }

        // trouver les "têtes" (non pointées)
        const heads = tasks.filter(t => !pointed.has(t.uid || t.id));

        const result: PlanningTask[] = [];

        function walk(start: PlanningTask) {
            let current: PlanningTask | undefined = start;

            while (current) {
                result.push(current);
                current = current.target ? map.get(current.target || "0") : undefined;
            }
        }

        // parcourir chaque chaîne
        for (const head of heads) {
            walk(head);
        }

        return result;
    }

    getMetricIcon(tag: string): string {
        let key = "other"
        tag = tag.toLowerCase();

        if (tag.includes("coulage")) {
            key = "concreting";
        } else if (tag == "banche") {
            key = "formwork";
        } else if (tag.includes("prédalle")) {
            key = "precast_slab";
        } else if (tag == "dalle") {
            key = "floor";
        } else if (tag.includes("armature")) {
            key = "reinforcement";
        } else if (tag.includes("mur") || tag.includes("prémur")) {
            key = "wall";
        } else if (tag.includes("poutre")) {
            key = "beam";
        } else if (tag.includes("poteau")) {
            key = "column";
        }

        return key
    }

    getMetricCategory(title: string): string {
        title = title.toLocaleLowerCase()
        let category = 'other';

        if (title.includes('coulage') || title == 'benne à béton') {
            category = 'concreting';
        } else if (title.includes('armature')) {
            category = 'reinforcement';
        } else if (title == 'banche') {
            category = 'formwork';
        } else if (title.includes('préfabriqué')) {
            category = 'prefabricated';
        } else if (title == 'prédalle') {
            category = 'precast_slab';
        }

        return category;
    }

    getFormattedBuildingType(buildingTypes: { [key: string]: string[] }, buildingType: string) {
        let type = Object.keys(buildingTypes).find((t: any) => buildingTypes![t]!.includes(buildingType))
        if (type) return type;
        return ""
    }

    getBuildingDuration(buildingTypes: { [key: string]: string[] }, buildingType: string, volume: number): number {
        let duration = 24;
        let formatedBuildingType = this.getFormattedBuildingType(buildingTypes, buildingType)

        switch (formatedBuildingType) {
            case 'wall':
                duration = 2 * (volume || 1)
                break;
            case 'prefaWall':
                duration = 1 * (volume || 1)
                break;
            case 'floor':
                duration = 2 * (volume || 1)
                break;
            case 'beam':
                duration = 2 * (volume || 1)
                break;
            case 'prefaBeam':
                duration = 1 * (volume || 1)
                break;
            case 'column':
                duration = 2 * (volume || 1)
                break;
            case 'prefaColumn':
                duration = 1 * (volume || 1)
                break;
            case 'foundation':
                duration = 2 * (volume || 1)
                break;
            case 'stair':
                duration = 2
                break;
        }
        return duration / 24;
    }

    getBuildingCost(buildingTypes: { [key: string]: string[] }, buildingType: string, volume: number): number {
        let duration = 1;
        let formatedBuildingType = this.getFormattedBuildingType(buildingTypes, buildingType)

        switch (formatedBuildingType) {
            case 'wall':
                100 * (volume || 1)
                break;
            case 'prefaWall':
                100 * (volume || 1)
                break;
            case 'floor':
                100 * (volume || 1)
                break;
            case 'beam':
                100 * (volume || 1)
                break;
            case 'prefaBeam':
                100 * (volume || 1)
                break;
            case 'column':
                100 * (volume || 1)
                break;
            case 'prefaColumn':
                100 * (volume || 1)
                break;
            case 'foundation':
                100 * (volume || 1)
                break;
            case 'stair':
                500 * (volume || 1)
                break;
        }
        return duration;
    }

    setTaskPriority(task: PlanningTask, currentDate: string): void {
        // if (task.text == "R-1 BA Voiles-poteaux-maçonnerie_Bât A")
        if (task.fragments && task.fragments.length) {
            //late
            if (task.doneDate && moment(task.doneDate).isBefore(currentDate)) {
                task.priority = "done";
            } else if (task.progress != 1 && moment(task.endDate!).isBefore(currentDate)) {
                if (task.doneDate && moment(task.doneDate).isBefore(currentDate)) {
                    task.priority = "done";
                } else if (!task.doneDate && moment(task.endDate).isBefore(currentDate)) {
                    task.priority = "done";
                } else {
                    task.priority = "late";
                }
                //progress
            } else if (task.progress == 0 && moment(task.startDate!).isAfter(currentDate)) {
                task.priority = "waiting";
                //progress
            } else if (task.progress == 1) {
                task.priority = "done";
                //forEache
            } else if (task.progress && task.progress > 0 && task.progress < 1) {
                task.priority = "progress";
                //done
            } else {
                task.priority = "todo";
            }

            switch (task.priority) {
                case "waiting":
                    task.color = Config.colors.mute;
                    break;
                case "todo":
                    task.color = Config.colors.warning;
                    break;
                case "progress":
                    task.color = Config.colors.primary;
                    break;
                case "late":
                    task.color = Config.colors.danger;
                    break;
                case "done":
                    task.color = Config.colors.success;
                    break;
                default:
                    task.color = Config.colors.mute;
                    break;

            }
        }
    }

}